"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelDropdownMini = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    children = null,
    className = '',
    iconName = '',
    links = [],
    rightAligned = false,
    smallList = false,
    topOffset = 0
  } = props;
  const itemClass = iClass => iClass || '';
  const classesByProps = () => {
    let finalClass = '';
    smallList ? finalClass += 'smallList' : finalClass += 'menuDropdown';
    rightAligned ? finalClass += ' alignedRight' : null;
    iconName ? finalClass += ' withIcon' : null;
    return finalClass;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `dropdownMini ${className} ${classesByProps()}`,
    style: {
      top: topOffset
    },
    ref: ref
  }, children ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children)) : (/*#__PURE__*/_react.default.createElement("ul", null, links.map((item, i) => (/*#__PURE__*/_react.default.createElement("li", {
    key: `lnk_${i.toString()}`,
    className: `dropdownItem fsize-300 pos-r txtText900 ${itemClass(item.className || '')}`,
    onClick: e => item.clickFunc ? item.clickFunc(e) : ''
  }, item.label))))));
});
BrixelDropdownMini.displayName = 'BrixelDropdownMini';
var _default = exports.default = BrixelDropdownMini;